import { ActionHandler, ActionHandlerParams } from "..";
import { onStartSurvey } from "./onStartSurvey";
import { getPageSetSurvey } from "./util";
import getStore from "src/utils/redux/store";
import { trackBuyflowEvent } from "src/utils/api/tracker";
import { trackCurrentTierEvent } from "src/utils/counterOffer";
import { trackCancellationSurveyFinished } from "src/components/counter-offer/tracking";
import saveToBraze from "src/utils/brazeUploader";
import { resetCurrentAnswers } from "@utils/redux/slices/currentAnswers";
import { resetCounterOffer } from "src/utils/redux/slices/counterOffer";
import { resetBillingDataCache } from "src/utils/redux/slices/billingData";
import { Survey } from "@pageDefinitions/types";

/**
 * When a PageSet splits `actions` and the named survey `block` into separate
 * sibling entries, the action's `page` has no `name`. This resolves the actual
 * survey block and its surveyNameSpace so downstream helpers work correctly.
 */
export function resolveSurveyPage(
  actionConfig: ActionHandlerParams
): ActionHandlerParams & {
  surveyNameSpace: Survey["surveyNameSpace"];
} {
  const { pageSet, page } = actionConfig;
  const surveyBlock = pageSet.pages.find((p) => "name" in p) || page;
  const { surveyNameSpace } = getPageSetSurvey(pageSet, surveyBlock);
  return { ...actionConfig, page: surveyBlock, surveyNameSpace };
}

export const onStartCancellationSurvey: ActionHandler = (actionConfig) => {
  const resolvedConfig = resolveSurveyPage(actionConfig);
  onStartSurvey(resolvedConfig);
  const store = getStore();
  const { serverContext } = store.getState();

  const eventData = {
    subscriptionId: serverContext.subscription_id,
    isOnInstallments: serverContext.is_on_installments,
    hasDiscount: !!serverContext.promo_code,
  };
  trackBuyflowEvent("CancellationSurveyStarted", eventData);
  saveToBraze({
    event: {
      event_name: "CancellationSurveyStarted",
      event_data: eventData,
    },
  });
  trackCurrentTierEvent();

  store.dispatch(resetCounterOffer());
  resetBillingDataCache();
  store.dispatch(
    resetCurrentAnswers({
      namespace: resolvedConfig.surveyNameSpace,
      answers: {},
    })
  );
};

export const onCompleteCancellationSurvey: ActionHandler = () => {
  trackCancellationSurveyFinished();
};
